import React from "react";
import { Box, Button, IconButton, styled } from "@mui/material";
import DeleteIcon from "@mui/icons-material/DeleteOutline";
import { GrTarget } from "react-icons/gr";
import { CiViewList } from "react-icons/ci";
import { useNavigate } from "react-router-dom";
import StatusPill from "./StatusPill";

const GreyStyledButton = styled(Button)(() => ({
  width: "fit-content",
  backgroundColor: "#fff",
  borderRadius: "12px",
  fontSize: "14px",
  fontWeight: 500,
  boxShadow: "none",
  color: "#0D0D0E",
  border: "1px solid #1212151A",
  cursor: "pointer",
  fontFamily: "Inter Tight",
  whiteSpace: "nowrap",
  textTransform: "none",
  padding: "6px 14px",
  "&:hover": {
    border: "1px solid #1212151A",
    color: "#0D0D0E",
    backgroundColor: "#F9FAFB",
  },
}));

const BOMSummaryButton = styled(Button)(() => ({
  backgroundColor: "#fff",
  color: "#2563EB",
  border: "1px solid #BFDBFE",
  borderRadius: "6px",
  padding: "6px 12px",
  fontSize: "12px",
  fontWeight: 500,
  boxShadow: "none",
  textTransform: "none",
  whiteSpace: "nowrap",
  display: "flex",
  alignItems: "center",
  gap: "4px",
  fontFamily: "Inter Tight",
  "&:hover": {
    backgroundColor: "#EFF6FF",
    border: "1px solid #BFDBFE",
    color: "#2563EB",
    boxShadow: "none",
  },
}));

const ScopeList = ({
  scopes,
  handleManageEdit,
  handleDelete,
  details,
  passedStyles,
  showActions = true,
}) => {
  const navigate = useNavigate();

  const handleBOMSummaryClick = (scope) => {
    navigate(`/project/details/${details?.id}/bom-summary/${scope.scope_id}`, {
      state: {
        projectDetails: details,
        selectedScopeId: scope.scope_id,
        selectedScopeName: scope.name,
        passedStyles: passedStyles,
      },
    });
  };

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
      {scopes.map((scope) => {
        const hasBids = Array.isArray(scope.bids) && scope.bids.length > 0;
        return (
        <Box
          key={scope.scope_id}
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            gap: 2,
            p: 2,
            border: "1px solid #e0e0e0",
            borderRadius: "12px",
            backgroundColor: "#fff",
            boxShadow: "0 1px 2px rgba(0,0,0,0.05)",
            flexWrap: "wrap",
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 2,
              minWidth: 0,
              flex: 1,
            }}
          >
            <Box
              sx={{
                backgroundColor: "#eff6ff",
                borderRadius: "8px",
                p: 1.5,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexShrink: 0,
              }}
            >
              <GrTarget size={18} />
            </Box>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                gap: "4px",
                minWidth: 0,
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 1,
                  flexWrap: "wrap",
                }}
              >
                <Box
                  sx={{
                    fontSize: "15px",
                    fontWeight: 500,
                    color: "#0D0D0E",
                  }}
                >
                  {scope.name}
                </Box>
                <StatusPill status={scope.status} />
              </Box>
              <Box
                sx={{
                  fontSize: "14px",
                  color: "#949daa",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                }}
              >
                {scope.description || "-"}
              </Box>
            </Box>
          </Box>

          <Box sx={{ display: "flex", gap: 1, alignItems: "center" }}>
            <BOMSummaryButton
              variant="outlined"
              onClick={(e) => {
                e.stopPropagation();
                handleBOMSummaryClick(scope);
              }}
            >
              <CiViewList style={{ fontSize: "16px" }} />
              BOM Summary
            </BOMSummaryButton>
            {showActions && !hasBids && (
              <>
                <GreyStyledButton
                  variant="outlined"
                  onClick={(e) => {
                    e.stopPropagation();
                    handleManageEdit(scope);
                  }}
                >
                  Edit
                </GreyStyledButton>
                <IconButton
                  size="small"
                  onClick={(e) => {
                    e.stopPropagation();
                    if (handleDelete) handleDelete(scope);
                  }}
                  sx={{
                    border: "1px solid #FCA5A5",
                    borderRadius: "8px",
                    width: 34,
                    height: 34,
                    "&:hover": { backgroundColor: "#FEF2F2" },
                  }}
                >
                  <DeleteIcon sx={{ fontSize: 18, color: "#DC2626" }} />
                </IconButton>
              </>
            )}
          </Box>
        </Box>
        );
      })}
    </Box>
  );
};

export default ScopeList;
